import React, {useState} from 'react';
import {SyncOutlined} from '@ant-design/icons';
import {Button, notification, Tooltip} from 'antd';
import {onboardEmployee} from '../api/employeeApi';

const OnboardButton = ({employee}) => {
  const [loading, setLoading] = useState(false);

  const onboard = async () => {
    try {
      setLoading(true);
      const {status} = await onboardEmployee(employee);
      if (status === 200) {
        notification.success({
          message: 'Success',
          description: `${employee.fullName} is now being synchronized!`,
          placement: 'bottomRight',
        });
      } else if (status === 400) {
        notification.warning({
          message: 'Synchronization in Process',
          description: `${employee.fullName} is still being synchronized, please wait.`,
          placement: 'bottomRight',
        });
      }
    } catch (e) {
      console.error(`Could not synchronize employee ${employee.email}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Synchronize">
      <Button onClick={onboard} loading={loading} icon={<SyncOutlined/>}/>
    </Tooltip>
  );
};

export {OnboardButton};
